var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSavePro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 212,
    viewBox: "0 0 212 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17491_97123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.3825 -12.9165L121.439 -18.4771L228.858 89.053L223.283 147.264L63.3825 -12.9165Z",
    fill: "url(#paint0_linear_17491_97123)",
    fillOpacity: 0.4,
    stroke: "url(#paint1_linear_17491_97123)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17491_97123",
    x1: 259.134,
    y1: 112.913,
    x2: 176.634,
    y2: 165.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17491_97123",
    x1: 259.134,
    y1: 112.913,
    x2: 176.634,
    y2: 165.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1278A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DBD94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17491_97123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 212,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavePro);
export default __webpack_public_path__ + "static/media/savePro.34a311f0a4249920d01d577537da225f.svg";
export { ForwardRef as ReactComponent };